var map = {
	"./varian.de.json": [
		7453,
		7453
	],
	"./varian.en-au.json": [
		6582,
		6582
	],
	"./varian.en-gb.json": [
		3681,
		3681
	],
	"./varian.es-419.json": [
		7597,
		7597
	],
	"./varian.es.json": [
		6386,
		6386
	],
	"./varian.fr-ca.json": [
		8521,
		8521
	],
	"./varian.fr.json": [
		8554,
		8554
	],
	"./varian.ja.json": [
		3255,
		3255
	],
	"./varian.pt-br.json": [
		5265,
		5265
	],
	"./varian.pt-pt.json": [
		3901,
		3901
	],
	"./varian.zh-hans.json": [
		8651,
		8651
	],
	"./varian.zh-hant.json": [
		7846,
		7846
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7489;
module.exports = webpackAsyncContext;